import React from 'react';
import { Box, Paper, List, ListItem, ListItemButton, ListItemText, FormControl, InputLabel, Select, MenuItem, Typography } from '@mui/material';
import { useSelector } from 'react-redux';
import { setSelectedRole } from '../app/loginSlice';
import { dispatchUsersForRole } from '../app/usersSlice';
import { setShallLoadActivity } from '../app/activitiesSlice.js';
import Button from '@msi/cobalt-react/button';
import {Dropdown, DropdownItem} from '@msi/cobalt-react/dropdown';
import ArrowDown from '@msi/cobalt-react/icons/arrow-down';

const LeftMenu = ({ onMenuSelect, dispatch }) => {
  const allUsers = useSelector((state) => state.users.allUsers);
  const managedUsers = useSelector((state) => state.users.managedUsers);
  const userObj = useSelector((state) => state.users.userObj);
  const coreId = useSelector((state) => state.login.coreId || '');
  var userName = (userObj && userObj?.name) ? userObj?.name : '';
  userName = window._loginUserName || userName;

  const onSelectRole = (role) => {
    console.log('Selected role:', role);
    dispatchUsersForRole(dispatch, role, allUsers, managedUsers, userObj);
    dispatch(setSelectedRole(role));
    dispatch(setShallLoadActivity(true));
  };
  
  const menuItems = [
    { name: 'Dashboard',    showIfUser: true,  showIfManager: true, showIfAdmin: true },
    { name: 'Activities',   showIfUser: true,  showIfManager: true, showIfAdmin: true },
    { name: 'Levels', showIfUser: true,  showIfManager: true, showIfAdmin: true },
    { name: 'Summary',      showIfUser: false,  showIfManager: false, showIfAdmin: false },
    { name: 'Scoring Rules',showIfUser: true,  showIfManager: true, showIfAdmin: true },
    { name: 'Digital Swag', showIfUser: true,  showIfManager: true, showIfAdmin: true },
    { name: 'SWAG',         showIfUser: false,  showIfManager: false, showIfAdmin: false },
    { name: 'FAQ',          showIfUser: true,  showIfManager: true, showIfAdmin: true },
    { name: 'Badge Rules',  showIfUser: false,  showIfManager: false, showIfAdmin: false },
    { name: 'Users',        showIfUser: false, showIfManager: true, showIfAdmin: true },
  ];
  const roles = useSelector((state) => state.login.roles);
  const selectedRole = useSelector((state) => state.login.selectedRole);
  const field = { User : 'showIfUser', Manager : 'showIfManager', Admin : 'showIfAdmin' }[selectedRole];
  const showMenuItems = menuItems.filter((item) => item[field]);

  return roles ? (
    <Paper elevation={3} className="left-menu" sx={{ padding: 2, ml: 2, mr: 2, backgroundColor: (theme) => theme.palette.secondary.main, color: (theme) => theme.palette.text.main }}>
      <Typography sx={{ padding: '16px' }}>{`${userName} ${coreId.toUpperCase()}`}</Typography>
      <Box sx={{ ml: 3, mr: 1}}>
      <InputLabel shrink sx={{color: (theme) => theme.palette.text.main, px: 0.5 }}>Select Role</InputLabel>
      <Dropdown
        anchor={function noRefCheck(){
          return <Button buttonType='secondary' size='large'>{selectedRole}<ArrowDown /></Button>;
        }}
        position='bottom'
      >
        {
          roles.map((role) => (
            <DropdownItem 
              onClick={() => {
                onSelectRole(role)
              }}
            >{role}</DropdownItem>
          ))
        }
      </Dropdown>
      </Box>
      <List>
        {showMenuItems.map((item) => (
            <ListItem key={item.name}>
              <Box sx={{ m: 1, width: '100%' }} ><Button buttonType='action' text={item.name} onClick={() => typeof onMenuSelect === 'function' && onMenuSelect(item.name)} /></Box>
            </ListItem>
          ))}
      </List>
    </Paper>
  ) : '';
};

export default LeftMenu;
